import React from 'react';
import * as Element from './Switch.styles';
export function Switch(_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, statusProp = _a.status, onChange = _a.onChange, disabled = _a.disabled;
    var _c = React.useState(statusProp), status = _c[0], setStatus = _c[1];
    React.useEffect(function () {
        setStatus(statusProp);
    }, [statusProp]);
    var handleChange = function () {
        if (disabled === true || onChange === undefined) {
            return;
        }
        setStatus(status === 'on' ? 'off' : 'on');
        onChange();
    };
    return (React.createElement(Element.Container, { size: size, status: status, disabled: disabled, onClick: handleChange },
        React.createElement(Element.Dot, { size: size, status: status })));
}
//# sourceMappingURL=Switch.js.map